import React from 'react';
import { FaBoxes, FaHandshake, FaIndustry, FaShieldAlt } from 'react-icons/fa';

const B2BEntryModal = ({ onContinue }) => {
    return (
        <div className="b2bEntryOverlay">
            <div className="b2bEntryModal">
                <div className="modalHeader" style={{ flexDirection: "column" }}>
                    <h2>Chocowi B2B Marketplace</h2>
                    <p>Wholesale & Bulk Purchasing for Businesses</p>
                </div>
                <div className="modalBody">
                    <ul className="featureList">
                        <li>
                            <div className="featureIcon"><FaBoxes /></div>
                            <div>
                                <strong>Bulk Orders Only</strong> - This marketplace is designed for wholesale purchasing with minimum order quantities. Prices decrease with larger orders.
                            </div>
                        </li>
                        <li>
                            <div className="featureIcon"><FaHandshake /></div>
                            <div>
                                <strong>Business to Business</strong> - All suppliers are verified businesses. Transactions here are between businesses, not individual consumers.
                            </div>
                        </li>
                        <li>
                            <div className="featureIcon"><FaIndustry /></div>
                            <div>
                                <strong>Custom Manufacturing</strong> - Many suppliers offer customization and private labeling. Send queries to discuss your specific requirements.
                            </div>
                        </li>
                        <li>
                            <div className="featureIcon"><FaShieldAlt /></div>
                            <div>
                                <strong>Verified Suppliers</strong> - All B2B sellers go through an application and approval process to ensure quality and reliability.
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="modalFooter">
                    <button className="continueBtn" onClick={onContinue}>
                        I Understand, Continue to B2B Marketplace
                    </button>
                </div>
            </div>
        </div>
    );
};

export default B2BEntryModal;
